module.exports = __webpack_public_path__ + "static/media/1.28804d9a.jpg";